module.exports = __webpack_public_path__ + "img/Tunisia.ca1387a5.svg";